export const formatPriceCoefficient = (value, fallback = '1.0') => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return fallback;

  const roundedValue = Number(numericValue.toFixed(4));
  const formattedValue = roundedValue
    .toFixed(4)
    .replace(/0+$/, '')
    .replace(/\.$/, '');

  return formattedValue.includes('.') ? formattedValue : `${formattedValue}.0`;
};

export const formatPriceCoefficientLabel = (value, fallback = '1.0') => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return fallback;
  return `×${formatPriceCoefficient(numericValue, fallback)}`;
};

export const getDepartmentPriceCoefficient = (department, clientType) => {
  if (!department) return 1.0;
  const normalizedType = String(clientType || '').trim().toLowerCase();
  const isB2B = normalizedType === 'b2b' || normalizedType === 'organization' || normalizedType === 'company';
  const coeff = isB2B
    ? (department.price_coefficient_b2b ?? department.price_coefficient)
    : (department.price_coefficient_b2c ?? department.price_coefficient);
  const num = Number(coeff);
  return Number.isFinite(num) && num > 0 ? num : 1.0;
};
